import React from "react";
import { useTranslation } from "react-i18next";

import "./ActualityPage.css";

import programImage from "../images/ProgramCongresMontreal.jpg";

import photoCongres1 from "../images/photoCongres1.jpeg";
import photoCongres2 from "../images/photoCongres2.jpeg";
import photoCongres3 from "../images/photoCongres3.jpeg";
import photoCongres4 from "../images/photoCongres4.jpeg";
import photoCongres5 from "../images/photoCongres5.jpeg";
import photoCongres6 from "../images/photoCongres6.jpeg";
import photoCongres7 from "../images/photoCongres7.jpeg";
import photoCongres8 from "../images/photoCongres8.jpeg";

import congresVideo from "../videos/bakongCongresVideo.mp4";

export default function ActualityPage() {

    const { t } = useTranslation();

    const gallery = [
        photoCongres1,
        photoCongres2,
        photoCongres3,
        photoCongres4,
        photoCongres5,
        photoCongres6,
        photoCongres7,
        photoCongres8
    ];

    return (

<div className="actuality-container">

<h1>{t("menu.news")}</h1>

<p className="intro">

{t("menu.description")}

</p>

<section className="program-section">

<img
src={programImage}
alt="Programme"
className="program-image"
/>

</section>

<section className="video-section">

<h2>{t("menu.videoCongres")}</h2>

<video
controls
className="video-player">

<source
src={congresVideo}
type="video/mp4"
/>

</video>

</section>

<section className="highlight-section">

<h2>{t("menu.highlightsCongres")}</h2>

<ul>

<li>{t("menu.itemCongres1")}</li>

<li>{t("menu.itemCongres2")}</li>

<li>{t("menu.itemCongres3")}</li>

<li>{t("menu.itemCongres4")}</li>

</ul>

</section>

<section className="gallery-section">

<h2>{t("menu.galleryCongres")}</h2>

<div className="gallery">

{

gallery.map((image,index)=>(

<img
key={index}
src={image}
alt={"photoCongres"+index}
/>

))

}

</div>

</section>

</div>

);

}